import { render, staticRenderFns } from "./VehicleInformationScatterChart.vue?vue&type=template&id=3ff7f8b4&scoped=true&"
import script from "./VehicleInformationScatterChart.vue?vue&type=script&lang=js&"
export * from "./VehicleInformationScatterChart.vue?vue&type=script&lang=js&"
import style0 from "./VehicleInformationScatterChart.vue?vue&type=style&index=0&id=3ff7f8b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff7f8b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VDivider,VRow})
